import React from "react";
import RowBanner from "../../components/shared/row-banner/RowBanner";
import './StudentExam.scss';
import Calculator from '../../assest/images/exam/calculator.svg';
import ExamResult from '../../assest/images/exam/natayejAzmon.svg';
import StartExam from '../../assest/images/exam/startExam.svg';

export default class StudentExam extends React.PureComponent {

    render(): React.ReactNode {
        return (<>
            <div className="dropdown-list  student-exam-area">
                <div className="col-12 col-md-12 tk-padding-top">
                    <div className="row" style={{ margin: "0" }}>
                        <div className="col-12 col-md-12  px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/StartExam", title: "شرکت در آزمون", imageSource: StartExam }} />
                        </div>
                        <div className="col-12 col-md-12   px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/ExamCalculator", title: "ماشین حساب آزمون", imageSource: Calculator }} />
                        </div>
                        <div className="col-12 col-md-12  px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/ViewExamResults", title: "مشاهده نتایج آزمون", imageSource: ExamResult }} />
                        </div>
                    </div>
                </div >
            </div >
        </>);
    }   
}